import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { AccessoryCharge, PaymentCart } from '@cargos/sprintpay-models';
import { Subject, map, takeUntil } from 'rxjs';
import { CartBillService, ConfigService, DynamicsFieldsService, SummaryService } from 'src/app/shared/services';
import { AccessoriesService } from '../../services/accessories/accessories.service';

@Component({
    standalone: true,
    selector: 'app-summary-item',
    templateUrl: './summary-item.component.html',
    styleUrls: ['./summary-item.component.scss'],
    imports: [CommonModule, MatIconModule],
})
export class SummaryItemComponent implements OnInit, OnDestroy {
    public customerReferenceLabel: string;
    private unsubscribe$: Subject<void>;
    public mawb: string | null;
    public quantity: number;
    public showIcon = false;
    public calculateQuantityByExtraItems = false;
    public awbLabel: string;

    @Input() item: PaymentCart;

    constructor(
        private summaryService: SummaryService,
        private accessoriesService: AccessoriesService,
        private cartBillService: CartBillService,
        private dynamicFieldsService: DynamicsFieldsService,
        private configService: ConfigService
    ) {
        this.unsubscribe$ = new Subject<void>();
    }

    ngOnInit(): void {
        this.getCustomerReferenceLabel();
        this.getConfig();
        this.mawb = this.summaryService.getMAWB();
        this.subscribeItemsDuplicates();

        if (this.item.isAccessorial && this.calculateQuantityByExtraItems) {
            this.getItemRate();
        }
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    getConfig(): void {
        this.calculateQuantityByExtraItems = this.configService.calculateQuantityByExtraItems();
        const labelAwb = this.configService.getLabelAWB();
        const labelHawb = this.configService.getLabelHAWB();

        this.awbLabel = this.item.hawb ? labelHawb : labelAwb;
    }

    getCustomerReferenceLabel(): void {
        this.dynamicFieldsService
            .getFieldLabelByName('customerRef')
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next: (fieldLabel) => {
                    this.customerReferenceLabel = fieldLabel;
                },
            });
    }

    subscribeItemsDuplicates(): void {
        this.cartBillService
            .isThereDuplicatesByPayment(this.item)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((isDuplicated) => {
                this.showIcon = isDuplicated;
            });
    }

    getItemRate(): void {
        if (!this.item.externalData?.paymentType) {
            return;
        }

        this.accessoriesService
            .getAccessoryRateByPaymentType(this.item.externalData?.paymentType)
            .pipe(
                map((rate) => {
                    if (rate) {
                        this.quantity = AccessoryCharge.calculateTotalItems(this.item.amount || 0, rate);
                    }
                }),
                takeUntil(this.unsubscribe$)
            )
            .subscribe();
    }
}
